var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIaqIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.7 64.9",
    style: {
      enableBackground: "new 0 0 115.7 64.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#424242;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0.8,
    className: "st0",
    width: 9.4,
    height: 54.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.8,0.8h-4.1h-2.2L16.9,55.4h9.9l4.4-12.8h21.2l4.4,12.8h9.9L46,0.8H43.8z M33.8,35.1l8-23.2l8,23.2H33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114,40.7c1.1-3.3,1.6-7,1.6-11.1v-3c0-4.1-0.6-7.8-1.7-11.1c-1.1-3.3-2.6-6.1-4.6-8.4c-2-2.3-4.4-4.1-7.2-5.3 C99.4,0.6,96.3,0,92.9,0c-3.4,0-6.4,0.6-9.2,1.8c-2.8,1.2-5.1,3-7.2,5.3c-2,2.3-3.6,5.1-4.7,8.4c-1.1,3.3-1.7,6.9-1.7,11.1v3 c0,4.1,0.6,7.8,1.7,11.1c1.1,3.3,2.7,6.1,4.7,8.4c2,2.3,4.4,4.1,7.2,5.3c2.8,1.2,5.8,1.8,9.2,1.8c1.7,0,3.3-0.2,4.9-0.5l11.5,9.2 l6.1-5.4l-9.4-7.5c1.2-0.9,2.3-1.9,3.3-3C111.4,46.8,113,44,114,40.7z M106.2,29.6c0,3.1-0.3,5.8-0.9,8.1c-0.6,2.4-1.4,4.3-2.6,6 c-1.1,1.6-2.5,2.8-4.1,3.6c-1.6,0.8-3.5,1.2-5.6,1.2c-2.1,0-3.9-0.4-5.6-1.2c-1.6-0.8-3-2-4.2-3.6c-1.2-1.6-2-3.6-2.6-6 c-0.6-2.4-0.9-5.1-0.9-8.1v-3.1c0-3.1,0.3-5.7,0.9-8.1c0.6-2.4,1.5-4.3,2.6-5.9c1.2-1.6,2.5-2.8,4.2-3.6c1.6-0.8,3.5-1.2,5.5-1.2 c2.1,0,4,0.4,5.6,1.2c1.7,0.8,3,2,4.2,3.6c1.2,1.6,2,3.5,2.6,5.9c0.6,2.3,0.9,5,0.9,8.1V29.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIaqIndicator);
export default __webpack_public_path__ + "static/media/IAQIndicator.4264ae41ac26c1c2d126435877a96bf7.svg";
export { ForwardRef as ReactComponent };